import { render } from "./ArchiveInsurance.vue?vue&type=template&id=3f5dca9a&scoped=true"
import script from "./ArchiveInsurance.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveInsurance.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveInsurance.vue?vue&type=style&index=0&id=3f5dca9a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5dca9a"],['__file',"src/components/cases/billingInfo/forms/ArchiveInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f5dca9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f5dca9a', __exports__)) {
    console.log('reload')
    api.reload('3f5dca9a', __exports__)
  }
  
  module.hot.accept("./ArchiveInsurance.vue?vue&type=template&id=3f5dca9a&scoped=true", () => {
    console.log('re-render')
    api.rerender('3f5dca9a', render)
  })

}


export default __exports__